import { toLoginEmail } from '../utils/login-identifier'
import apiClient from '../utils/axios'

export interface LoginRequest {
  email: string
  password: string
  rememberMe?: boolean
}

export interface LoginResponse {
  accessToken: string
  refreshToken: string
  expiresIn: number
  tokenType: string
  userInfo: {
    id: string
    email: string
    displayName: string
    roles: string[]
  }
}

export interface RefreshTokenRequest {
  refreshToken: string
}

export const authApi = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/Auth/login', {
      // A bare username ("kazemi.mst") means that account's email on our domain.
      email: toLoginEmail(credentials.email),
      password: credentials.password,
      rememberMe: credentials.rememberMe || false
    })
    return response.data
  },

  logout: async (): Promise<void> => {
    // The refresh token goes along so the server revokes it; it used to stay valid after logout (security audit
    // 2026-10-07, A5).
    const refreshToken = localStorage.getItem('admin_refresh_token')
    await apiClient.post('/Auth/logout', refreshToken ? { refreshToken } : {})
    localStorage.removeItem('admin_token')
    localStorage.removeItem('admin_refresh_token')
  },

  getCurrentUser: async () => {
    const response = await apiClient.get('/Users/me')
    return response.data
  },

  refreshToken: async (refreshToken: string): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/Auth/refresh', {
      refreshToken
    })
    return response.data
  },
}
